export const IMAGES = {
  logo: 'https://cdn.magicpatterns.com/uploads/aNzwRe8Sg621BnhoXwCyhP/Logo_Codigo_metabolico.png',
  colibri:
    'https://cdn.magicpatterns.com/uploads/w4UwedyNBbvEX5TLpHgnfd/Metabolismo_Colibri.png',
  jaguar:
    'https://cdn.magicpatterns.com/uploads/tUWNkQsvUodKM4joTd5NiB/Metabolismo_Jaguar.png',
  oso: 'https://cdn.magicpatterns.com/uploads/qyTWDmriB14xknkGREh3kc/Metabolismo_OSO.png',
  cover:
    'https://cdn.magicpatterns.com/uploads/xiSKuR6mrWqYspKY7n4oqp/Portada_de_FB.png',
}

export type MetabolicType = 'jaguar' | 'colibri' | 'oso'

export interface Option {
  text: string
  type: MetabolicType
}

export interface Question {
  id: number
  question: string
  options: Option[]
  weight: number
}

export const QUIZ_QUESTIONS: Question[] = [
  {
    id: 1,
    question: '¿Cómo es tu energía a lo largo del día?',
    weight: 2,
    options: [
      { text: 'Estable y constante, rara vez tengo bajones', type: 'oso' },
      {
        text: 'Alta en la mañana pero caigo fuerte en la tarde',
        type: 'jaguar',
      },
      {
        text: 'Sube y baja varias veces, es totalmente impredecible',
        type: 'colibri',
      },
    ],
  },
  {
    id: 2,
    question:
      'Después de comer arroz, pasta o pan en cantidad, ¿cómo te sientes?',
    weight: 2,
    options: [
      {
        text: 'Me da sueño y me siento pesado/a, como si necesitara una siesta',
        type: 'jaguar',
      },
      { text: 'Normal, no noto mucho cambio en mi cuerpo', type: 'oso' },
      {
        text: 'Me siento bien al inicio pero al rato ya tengo hambre otra vez',
        type: 'colibri',
      },
    ],
  },
  {
    id: 3,
    question: '¿En qué parte de tu cuerpo se acumula MÁS grasa?',
    weight: 2,
    options: [
      { text: 'En el abdomen y la cintura principalmente', type: 'jaguar' },
      {
        text: 'Se distribuye por todo el cuerpo de manera uniforme',
        type: 'oso',
      },
      {
        text: 'En caderas, muslos y brazos, pero el abdomen menos',
        type: 'colibri',
      },
    ],
  },
  {
    id: 4,
    question: '¿Qué pasa cuando te saltas una comida?',
    weight: 2,
    options: [
      {
        text: 'Me mareo, me pongo irritable o me tiemblan las manos',
        type: 'colibri',
      },
      { text: 'Puedo aguantar sin problema, casi ni lo noto', type: 'jaguar' },
      {
        text: 'Me da hambre pero puedo esperar sin mayor problema',
        type: 'oso',
      },
    ],
  },
  {
    id: 5,
    question: 'Cuando estás estresado/a o ansioso/a, ¿qué le pasa a tu cuerpo?',
    weight: 2,
    options: [
      { text: 'Como más de lo normal, especialmente en la noche', type: 'oso' },
      { text: 'Se me cierra el estómago, pierdo el apetito', type: 'jaguar' },
      {
        text: 'Me dan antojos intensos de dulce o carbohidratos',
        type: 'colibri',
      },
    ],
  },
  {
    id: 6,
    question: '¿Con qué frecuencia sientes hambre durante el día?',
    weight: 1,
    options: [
      {
        text: 'Cada 2-3 horas, si no como algo me siento mal',
        type: 'colibri',
      },
      { text: 'En mis horarios normales (3 veces al día)', type: 'oso' },
      {
        text: 'Pocas veces, puedo pasar muchas horas sin pensar en comida',
        type: 'jaguar',
      },
    ],
  },
  {
    id: 7,
    question:
      '¿Cómo te sientes después de comer proteína (carne, pollo, huevos)?',
    weight: 2,
    options: [
      { text: 'Satisfecho/a y con energía por varias horas', type: 'jaguar' },
      {
        text: 'Bien, pero necesito acompañarlo con arroz o pan para sentirme lleno/a',
        type: 'oso',
      },
      {
        text: 'Me lleno rápido pero al rato ya tengo hambre otra vez',
        type: 'colibri',
      },
    ],
  },
  {
    id: 8,
    question: '¿Qué tipo de antojo te domina más seguido?',
    weight: 1,
    options: [
      { text: 'Dulces, pan, galletas, chocolate', type: 'colibri' },
      { text: 'Comida salada, frituras, snacks', type: 'jaguar' },
      {
        text: 'Comida abundante: platos grandes, repetir porción',
        type: 'oso',
      },
    ],
  },
  {
    id: 9,
    question: '¿Cómo responde tu cuerpo cuando haces ejercicio?',
    weight: 2,
    options: [
      {
        text: 'Bajo de peso rápido al principio pero luego me estanco',
        type: 'jaguar',
      },
      {
        text: 'Me cuesta mucho ver resultados aunque sea constante',
        type: 'oso',
      },
      {
        text: 'Bajo y subo, los resultados son inconsistentes',
        type: 'colibri',
      },
    ],
  },
  {
    id: 10,
    question: '¿Cómo describirías tu digestión normalmente?',
    weight: 1,
    options: [
      {
        text: 'Rápida, proceso los alimentos sin mayor problema',
        type: 'jaguar',
      },
      {
        text: 'A veces me siento hinchado/a o inflamado/a después de comer',
        type: 'colibri',
      },
      { text: 'Lenta pero regular, sin molestias graves', type: 'oso' },
    ],
  },
  {
    id: 11,
    question:
      '¿Qué describe mejor tu relación con tu peso en los últimos años?',
    weight: 1,
    options: [
      { text: 'Subo y bajo como yo-yo, nunca me estabilizo', type: 'colibri' },
      { text: 'Subo gradualmente cada año, cada vez más', type: 'oso' },
      { text: 'Me mantengo pero con panza, no logro definir', type: 'jaguar' },
    ],
  },
  {
    id: 12,
    question: '¿Cómo es tu sueño y cómo te sientes al despertar?',
    weight: 1,
    options: [
      { text: 'Duermo bien y me despierto con energía', type: 'oso' },
      {
        text: 'Me cuesta dormir o me despierto en la madrugada',
        type: 'colibri',
      },
      {
        text: 'Duermo profundo pero me cuesta mucho levantarme',
        type: 'jaguar',
      },
    ],
  },
]

export const RESULT_CONTENT = {
  jaguar: {
    title: 'Jaguar',
    image: IMAGES.jaguar,
    explanation:
      'Tu cuerpo responde mejor a una alimentación que prioriza proteína y energía controlada. Eres un cazador natural, tu metabolismo está diseñado para ráfagas de energía y periodos de ayuno o comidas espaciadas.',
  },
  colibri: {
    title: 'Colibrí',
    image: IMAGES.colibri,
    explanation:
      'Tu cuerpo quema energía rápidamente y necesita combustible constante. Respondes mejor a comidas más pequeñas y frecuentes con una buena mezcla de carbohidratos complejos para mantener tu metabolismo acelerado.',
  },
  oso: {
    title: 'Oso',
    image: IMAGES.oso,
    explanation:
      'Tu metabolismo es fuerte y estable. Tu cuerpo responde bien a una alimentación equilibrada con comidas completas y tradicionales.',
  },
}
